import { render, staticRenderFns } from "./ProfileDrawer.vue?vue&type=template&id=dcb56ddc&scoped=true&"
import script from "./ProfileDrawer.vue?vue&type=script&lang=js&"
export * from "./ProfileDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDrawer.vue?vue&type=style&index=0&id=dcb56ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb56ddc",
  null
  
)

export default component.exports